export default ({keys, server}) => `package com.example.app

import android.app.Activity
import android.content.Intent
import android.os.Bundle
import android.widget.Button
import androidx.appcompat.app.AlertDialog
import androidx.appcompat.app.AppCompatActivity
import com.google.gson.GsonBuilder
import com.stripe.android.ApiResultCallback
import com.stripe.android.PaymentIntentResult
import com.stripe.android.Stripe
import com.stripe.android.model.ConfirmPaymentIntentParams
import com.stripe.android.model.StripeIntent
import com.stripe.android.view.CardInputWidget
import okhttp3.*
import okhttp3.MediaType.Companion.toMediaType
import okhttp3.RequestBody.Companion.toRequestBody
import org.json.JSONObject
import java.io.IOException
import java.lang.ref.WeakReference

class CheckoutActivity : AppCompatActivity() {
  // 10.0.2.2 is the Android emulator's alias to localhost
  private val backendUrl = "http://10.0.2.2:4242/"
  private val httpClient = OkHttpClient()
  private lateinit var paymentIntentClientSecret: String
  private lateinit var paymentLauncher: PaymentLauncher

  override fun onCreate(savedInstanceState: Bundle?) {
    super.onCreate(savedInstanceState)
    setContentView(R.layout.activity_checkout)
    {+load-stripe}
    // Configure the SDK with your Stripe publishable key so it can make requests to Stripe
    val paymentConfiguration = PaymentConfiguration.getInstance(applicationContext)
    paymentLauncher = PaymentLauncher.Companion.create(
        this,
        paymentConfiguration.publishableKey,
        paymentConfiguration.stripeAccountId,
        ::onPaymentResult
    )
    {/load-stripe}

    startCheckout()
  }

  private fun displayAlert(
    activity: Activity,
    title: String,
    message: String,
    restartDemo: Boolean = false
) {
    runOnUiThread {
      val builder = AlertDialog.Builder(activity)
        .setTitle(title)
        .setMessage(message)

      builder.setPositiveButton("Ok", null)
      builder.create().show()
    }
  }

  private fun startCheckout() {
    {+fetch-pi}
    val weakActivity = WeakReference<Activity>(this)
    // Create a PaymentIntent by calling your server's endpoint.
    val mediaType = "application/json; charset=utf-8".toMediaType()
    val requestJson = """
      {
          "currency":"usd",
          "items": [
              {"id":"xl-tshirt"}
          ]
      }
      """
    val body = requestJson.toRequestBody(mediaType)
    val request = Request.Builder()
      .url(backendUrl + "${
        server === 'php' ? 'create.php' : 'create-payment-intent'
      }")
      .post(body)
      .build()
    {/fetch-pi}
    httpClient.newCall(request)
        .enqueue(object: Callback {
          override fun onFailure(call: Call, e: IOException) {
            weakActivity.get()?.let { activity ->
                displayAlert(activity, "Failed to load page", "Error: $e")
            }
          }

          override fun onResponse(call: Call, response: Response) {
            if (!response.isSuccessful) {
                weakActivity.get()?.let { activity ->
                    displayAlert(
                        activity,
                        "Failed to load page",
                        "Error: $response"
                    )
                }
            } else {
                val responseData = response.body?.string()
                val responseJson =
                    responseData?.let { JSONObject(it) } ?: JSONObject()

                // For added security, our sample app gets the publishable key
                // from the server.
                paymentIntentClientSecret = responseJson.getString("clientSecret")
            }
          }
        })

    {+collect-details}
    // Hook up the pay button to the card widget and stripe instance
    val payButton: Button = findViewById(R.id.payButton)
    payButton.setOnClickListener {
      val cardInputWidget =
        findViewById<CardInputWidget>(R.id.cardInputWidget)
      cardInputWidget.paymentMethodCreateParams?.let { params ->
        {+finish}
        val confirmParams = ConfirmPaymentIntentParams
          .createWithPaymentMethodCreateParams(params, paymentIntentClientSecret)
        paymentLauncher.confirm(confirmParams)
        {/finish}
      }
    }
    {/collect-details}
  }

  {+handle-response}
  private fun onPaymentResult(paymentResult: PaymentResult) {
    var title = ""
    var message = ""
    var restartDemo = false
    when (paymentResult) {
        is PaymentResult.Completed -> {
            title = "Setup Completed"
            restartDemo = true
        }
        is PaymentResult.Canceled -> {
            title = "Setup Canceled"
        }
        is PaymentResult.Failed -> {
            title = "Setup Failed"
            message = paymentResult.throwable.message!!
        }
    }
    displayAlert(title, message, restartDemo)
  }
  {/handle-response}
}
`;
